module.exports = __webpack_public_path__ + "static/darkThree-f44ae2131a2cf700f8a1a917f0ac8613.png";